import * as UserApplicationsModule from './index';

export const User_AllApplications = {
    path: '/dashboard/allapplications',
    name: 'AllApplications',
    component: UserApplicationsModule.AllApplications,
};

export const User_AssignedApplications = {
    path: '/dashboard/assignedapplications',
    name: 'AssignedApplications',
    component: UserApplicationsModule.AssignedApplications,
};

export const User_CompletedApplications = {
    path: '/dashboard/completedapplications',
    name: 'AssignedApplications',
    component: UserApplicationsModule.CompletedApplications,
};